import $ from 'jquery';
import {AuthMode, AuthTokenStorage} from "src/core/gd/auth/@const";

// const debug = "AJAX AUTH REQUEST";
const debug = false;

const AjaxRequest = function(obj) {

    let result = $.Deferred();

    debug && console.log(debug, obj)

    const requestUrl = gdConfig.authApi + obj.endpoint;

    debug && console.log(debug, "request url=", requestUrl)


    let settings = {
        url: requestUrl,
        'xhrFields': {                              // enable browser to send cookie
            withCredentials: true
        }
    };

    if (obj.headers) {
        settings.headers = obj.headers;
    }

    switch (obj['type'].toUpperCase()) {
        case 'GET':
            settings['type'] = 'GET';
            settings['data'] = obj.data;
            settings['contentType'] = 'application/json';
            settings['dataType'] = 'json';
            break;
        case 'POST':
            settings['type'] = 'POST';
            settings['data'] = JSON.stringify(obj.data);
            settings['contentType'] = 'application/json';
            settings['dataType'] = 'json';
            break;
    }



    let ajax = $.ajax(settings).done(function (response, textStatus, request) {

        debug && console.log(debug, "Response=",response);

        // Process gd-auth-token update
        if (gd.auth && (gd.auth.authMode === AuthMode.TOKEN_OLD)) {
            debug && console.log(debug, "we are in auth token mode...")
            if (request.getResponseHeader('sessiontokenupdate')) {
                debug && console.log(debug, "we received a token - let's save it")
                gd.auth.saveAuthToken(request.getResponseHeader('sessiontokenupdate'));
            }
        }

        if (response) {
            if (response.session) {
                gd.session.processEvents(response.session);
            }
            if (response.data && response.data.session) {
                gd.session.processEvents(response.data.session);
            }
        }

        if (debug) console.log("resolve result=",result,"context=",obj.context,"data=",response);

        result.resolveWith(obj.context,[response])

    }).fail(function (jqXHR, exception) {

        let errorMessage = (jqXHR.responseJSON && jqXHR.responseJSON.errorMessage)?jqXHR.responseJSON.errorMessage:false;

        const errorsObj = {
            code: parseInt(jqXHR.status),
            errorMessage: errorMessage
        };

        gd.apiError(errorsObj);

        result.rejectWith(obj.context,[errorsObj]);
    });

    return result

};



module.exports = function (context, type, endpoint, data) {

    if (endpoint.substring(0,1)==='/') endpoint.substr(1);

    // add utcOffset
    // if (!data) data={};
    // data.zz = Moment().format("ZZ");

    const headers = {};
    if (gd.auth && (gd.auth.authMode === AuthMode.TOKEN_OLD || gd.auth.authMode === AuthTokenStorage.LOCAL)) {
        headers['SessionMode'] = 'token';
        headers['SessionToken'] = gd.auth.authToken;
    }

    return AjaxRequest({
        'type'      : type,
        'endpoint'  : endpoint,
        'data'      : data,
        'context'   : context,
        'headers'   : headers
    });

};
